import { useQuery } from 'hooks/useCustomQuery';
import getCallDetailRecords from 'API/CallDetailRecords/getCallDetailRecords';

const RECENT_CALLS_DAYS = 30;

// The CDR endpoint takes UTC timestamps as yyyy-MM-ddTHH:mm:ssZ.
const toUtcTimestamp = (date) => {
    const rounded = new Date(date);
    rounded.setSeconds(0, 0);
    return rounded.toISOString().split('.')[0] + 'Z';
};

/**
 * (3132) Whether the company has made any calls in the last 30 days. Only one
 * record is requested; the response's total is what matters.
 */
const useGetRecentCallRecords = (companyId, options = {}) =>
    useQuery({
        queryKey: ['setupProgress', 'callRecords', companyId],
        queryFn: async () => {
            const to = new Date();
            const from = new Date(to);
            from.setDate(from.getDate() - RECENT_CALLS_DAYS);

            const data = await getCallDetailRecords({
                companyId,
                from: toUtcTimestamp(from),
                to: toUtcTimestamp(to),
            });
            return (
                (data?.total ?? 0) > 0 ||
                (data?.callDetailRecords?.length ?? 0) > 0
            );
        },
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetRecentCallRecords;
